import store from 'app/redux/store';
import { removeStorageItem, storageKeys } from 'app/utils/localStorage';
import { Actions as QuestionsActions } from 'app/redux/ui/questions/actions';
import { Actions as QuestionsGetAllWorkerActions } from 'app/redux/questions/get-all/actions';

const clearQuestionStorage = () => {
  removeStorageItem(storageKeys.QUESTIONS_GET_ALL_RESULT);
  removeStorageItem(storageKeys.SELECTED_ANSWERS);
  store.dispatch(QuestionsActions.clearSelectedAnswers());
  store.dispatch(QuestionsGetAllWorkerActions.reset());
};

export default clearQuestionStorage;



// WEBPACK FOOTER //
// ./src/utils/clearQuestionStorage.js